var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackbone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1533_230",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1533_230)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 3V43.0188L40 60.0013V48.4565L19.9331 37.097V19.2573L40 30.6168V19.9593L10 3Z",
    fill: "#002A41",
    stroke: "#848484",
    strokeWidth: 0.072
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.9999 3V43.0188L39.9999 60.0013V48.4565L60.0668 37.097V19.2573L39.9999 30.6168V19.9593L69.9999 3Z",
    fill: "#0071B5",
    stroke: "#848484",
    strokeWidth: 0.072
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 77.0001V36.9789L40 19.9988V31.5413L19.9331 42.9008V59.8137L40 48.4797V60.0223L10 77.0001Z",
    fill: "#0071B5",
    stroke: "#848484",
    strokeWidth: 0.072
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.9999 76.9999V36.9787L39.9999 19.9985V31.5411L60.0668 42.9005V59.8135L39.9999 48.4795V60.022L69.9999 76.9999Z",
    fill: "#002A41",
    stroke: "#848484",
    strokeWidth: 0.072
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackbone);
export default __webpack_public_path__ + "static/media/Backbone.f7631b89a951fbc51652252bfe9ddfc3.svg";
export { ForwardRef as ReactComponent };